module.exports = __webpack_public_path__ + "static/media/old-2.f68713f3.jpeg";